/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Abilities_Group_KnowledgeInputs */



/**
* | output |
* | --- |
* | "Knowledge" |
*
* @param {Agent_Builder_Abilities_Group_KnowledgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_group_knowledge = /** @type {((inputs?: Agent_Builder_Abilities_Group_KnowledgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_Group_KnowledgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wissen")
	return /** @type {LocalizedString} */ ("Knowledge")
});